<template>
  <div class="wrap relative">
    <site-header bg="false"></site-header>

    <ContentSection skew="right" id="our-people" class="z-0 bg-tawnyorange-500 pb-16">
      <div class="grid grid-cols-12 gap-4">
        <div class="col-span-12 sm:col-span-10">
          <h1 class="text-4xl text-white" v-html="data.name">Case studies</h1>
          <p class="text-white text-sm font-light pt-12" v-html="data.updated"></p>
        </div>
      </div>
    </ContentSection>

    <div class="outer relative sect sect-cs-need" id="sect-cs-need">
      <div class="inner relative mb-0">
        <!-- <div class="sect-content"> -->
        <div class="csDescriptor">
          <div v-if="ready === false">
            <div class="loading">
              <div class="spinner">
                <div class="rect1"></div>
                <div class="rect2"></div>
                <div class="rect3"></div>
                <div class="rect4"></div>
                <div class="rect5"></div>
              </div>
            </div>
          </div>

          <div v-if="ready === true">
            <div v-if="success === true">
              <p class="copy-md">
                By downloading, installing or using this application you are agreeing to be bound by
                the terms and conditions of the
                <a
                  class="text-grey-700 underline hover:text-astralblue-700"
                  href="/products/CISynchronizer/EULA"
                  target="_blank"
                >
                  CI Synchronizer End User Licence Agreement (EULA)
                </a>
              </p>

              <div class="padd">
                <input
                  id="agree"
                  type="checkbox"
                  v-on:click="toggleAgreement()"
                  v-bind:value="agreed"
                />
                <label class="copy-md" for="agree"> I agree. </label>
              </div>
              <p class="copy-md">
                Please review the update set installation instructions from
                <a
                  class="text-grey-700 underline hover:text-astralblue-700"
                  target="_blank"
                  href="https://docs.servicenow.com/bundle/paris-application-development/page/build/system-update-sets/task/t_SaveAnUpdateSetAsAnXMLFile.html"
                >
                  ServiceNow
                </a>
                prior to installing.
              </p>

              <button
                type="button"
                class="button button--primary relative space"
                v-bind:class="{ notAgreed: !agreed }"
                @click="downloadButton"
              >
                Download the Pipefish
                <strong>CI Synchronizer - Lansweeper (on-prem) to ServiceNow Full Edition</strong>
              </button>
            </div>
            <div v-if="success === false">
              <h3 id="work" class="heading-two no-dash">
                Download link invalid or expired
              </h3>
            </div>
          </div>
        </div>
      </div>
    </div>

    <SiteFooter></SiteFooter>
  </div>
</template>

<script>
import _ from 'lodash';
import Axios from 'axios';

import SiteHeader from '@/components/SiteHeader.vue';
import SiteFooter from '@/components/Footer.vue';
import ContentSection from '@/components/ContentSection.vue';
import '@/components/svg/icon-check';
import '@/components/svg/chevron-left';
import '@/components/svg/chevron-right';

export default {
  name: 'ProductDownload',
  components: {
    SiteHeader,
    SiteFooter,
    ContentSection
  },
  data: function() {
    return {
      publicPath: process.env.BASE_URL,
      data: {},
      ready: false,
      success: false,
      downloadLink: '',
      agreed: false
    };
  },
  computed: {},
  methods: {
    toggleAgreement: function() {
      this.agreed = !this.agreed;
    },
    getData: function() {
      var vm = this;

      const downloadKey = this.$route.query.key;

      this.data = _.find(vm.Store.products, function(item) {
        return item.slug === vm.$route.params.product;
      });
      Axios.post('/.netlify/functions/verify-register', { key: downloadKey })
        .then(function(res) {
          if (res.data.success && res.data.downloadLink) {
            vm.downloadLink = res.data.downloadLink;
            vm.success = true;
            vm.ready = true;
          } else {
            vm.ready = true;
            vm.success = false;
          }
        })
        .catch(function() {
          vm.ready = true;
          vm.success = false;
        });
    },
    downloadButton: function() {
      if (this.agreed) {
        window.open(this.downloadLink);
      }
    }
  },
  mounted: function() {
    this.$nextTick(function() {
      this.getData();
    });
  }
};
</script>

<style lang="scss">
.section {
  @apply z-10 relative bg-grey-300 py-6 transform;
  .section-content {
    @apply relative max-w-5xl mx-auto transform;
  }
  &.transparent {
    background: transparent !important;
    h1,
    h2 {
      @apply text-grey-700;
    }
  }
  &.white {
    background: theme('colors.white');
  }
  &.astralblue {
    background: theme('colors.astralblue.500');
  }
  &.vividred {
    background: theme('colors.vividred.500');
  }
  &.skew-right {
    transform: skewY(2deg);
    @apply mt-12;
    .section-content {
      transform: skewY(-2deg);
    }
  }
  &.skew-left {
    transform: skewY(-2deg);
    @apply mt-12;
    .section-content {
      transform: skewY(2deg);
    }
  }
}
.submitting {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(#fff, 0.9);
  z-index: 200;
  .spinner {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
  }
}

.space {
  margin-top: 2rem;
}

.notAgreed {
  background: rgba(0, 0, 0, 0.1) !important;
  cursor: not-allowed !important;
}

.padd {
  padding: 2rem;
}
</style>
